import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//Reusable components
import Navbar from './components/Navbar/Navbar';
import NotFound from './components/404/NotFound';
import Footer from './components/Footer/footer';

//Pages Sections
import Hero from './components/LandingPage/HeroSection';
import WhyJoin from './components/LandingPage/WhyJoin';
import EmpowerSection from './components/LandingPage/EmpowerSection';
import NewsletterSection from './components/LandingPage/Newsletter';
import PartnerSection from './components/LandingPage/Partners';
import LinksSection from './components/LandingPage/ExploreLinks';
import ContactForm from './components/Contact/ContactForm';
import TeamGrid from './components/Team/TeamGrid';
import CommunityPage from './components/Community/CommunityPage';
import AboutCommunity from './components/About/AboutCommunity';
import FocusAreasSection from './components/About/FocusArea';
import PastEventsShowcase from './components/LandingPage/PastEventsShowcase';
import MissionSection from './components/About/MissionSection';
import QuoteSection from './components/About/QuoteSection';
import CampusAmbassadorProgram from './components/Ambassador/CampusAmbassador';
import WomenInQuantumPage from './components/WIQ/WomenInQuantumPage';
import Bootcamps from './components/Bootcamps/BootcampsPage';
import CommunityGuidelines from './components/Guidline/CommunityGuidelines';
import IYQ2025 from './components/IYQ/IYQ2025Page';


const App = () => {
  // Function to render shared page content
  const renderPageContent = () => (
    <div className="container">
      <EmpowerSection/>
      <WhyJoin/>
      <PastEventsShowcase/>
      <PartnerSection/>
      <NewsletterSection />
      <LinksSection/>
      <Footer/>
    </div>
  );

  return (
    <Router>
      <Navbar />

      <Routes>   
        {/* Fallback 404 route */}
        <Route path="*" element={<NotFound />} />
          
        {/* Landing Page Route */}
        <Route 
          path="/" 
          element={
            <>
              <Hero />
              {renderPageContent()}
            </>
          } 
        />

        {/* Join-Community Page Route */}
        <Route 
          path="/join-community" 
          element={
            <>
              <CommunityPage/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

        {/* About Page Route */}
        <Route 
          path="/about" 
          element={
            <>             
              <AboutCommunity/>
              <MissionSection/>
              <QuoteSection/>
              <FocusAreasSection/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

         {/* CampusAmbassadorProgram Page Route */}
         <Route 
          path="/ambassadors" 
          element={
            <>
              <CampusAmbassadorProgram/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

         {/* CampusAmbassadorProgram Page Route */}
         <Route 
          path="/wiq" 
          element={
            <>
              <WomenInQuantumPage/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

        {/* Bootcamps Page Route */}
         <Route 
          path="/bootcamps" 
          element={
            <>
              <Bootcamps/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />


         {/* Events */}
         <Route 
          path="/events" 
          element={
            <>
             
            </>
          } 
        />

        {/* Team Page Route */}
        <Route 
          path="/team" 
          element={
            <>             
              <TeamGrid/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

         {/* Contact Page Route */}
         <Route 
          path="/contact-us" 
          element={
            <>             
              <ContactForm/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

        {/* IYQ Page Route */}
         <Route 
          path="/iyq-2025" 
          element={
            <>             
              <IYQ2025/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

         {/* Guidlines Page Route */}
         <Route 
          path="/guidelines" 
          element={
            <>             
              <CommunityGuidelines/>
              <LinksSection/>
              <Footer/>
            </>
          } 
        />

      </Routes>  
    </Router>
  );
};

export default App;
